import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        getDetailScanData({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        "/supply-chains/raw-item-location-stock-details/scan-data",
                        {
                            params,
                        }
                    )
                    .then((res) => {
                        resolve(res.data.data.itemDetails);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {},
};
